export default __webpack_public_path__ + "static/media/create_a_rule.2fe9c09e.png";